const Event = require('../../../entities/Event');
const { Age } = require('../../../Constants/Constants');
const EventNames = require('../../Names/EventNames');

class ScientificBreakthrough extends Event {
    constructor(){
        super(
            Age.Age1,
            EventNames.ScientificBreakthrough,
            "Each civilization immediately scores science equal to the amount of science it produces.",
            {}
        )
    }
}

module.exports = ScientificBreakthrough;